export const CONTENTFUL_SPACE_ID = '1oxa8dhsnd7g'
export const CONTENTFUL_ACCESS_TOKEN = 'yY8dSqV7-3BbUqmEKrV1v6dVpr5i36NHxeg0r3Z1Ga0'
export const CONTENTFUL_BASE_URL = `https://cdn.contentful.com/spaces/${CONTENTFUL_SPACE_ID}/environments/master`

// Category names (match what was imported)
export const PROJECT_CATEGORY = 'PROJECT'
export const NEWS_CATEGORY = 'NEWS'
export const NEWS_EXTERNAL_CATEGORY = 'NEWS_EXTERNAL'

// WordPress IDs for special posts (same as before)
export const HOMEPAGE_SLIDESHOW = 63
export const HOMEPAGE_SLIDESHOW_MOBILE = 938
export const FOOTER_POST = 71
export const INFORMATION_POST = 76
export const OPERE_INFORMATION_POST = 149
